
const state = {
    actOper: [],
    device: {},
    group: {},
    orgProcess: [],
    htProcess: [],
    inspProcess: [],
    oper: [],
    firmCategory: [],
    deviceSite: [],
    deviceDepartment: [],
    deviceCategory: [],
    deviceState: [],
    repairOper: {},
    repairDevice: [],
}

const getters = {
    get_actOper: (state) => {
        return state.actOper;
    },
    get_device: (state) => {
        return state.device;
    },
    get_group: (state) => {
        return state.group;
    },
    get_orgProcess: (state) => {
        return state.orgProcess;
    },
    get_htProcess: (state) => {
        return state.htProcess;
    },
    get_inspProcess: (state) => {
        return state.inspProcess;
    },
    get_oper: (state) => {
        return state.oper;
    },
    get_firmCategory: (state) => {
        return state.firmCategory;
    },
    get_deviceSite: (state) => {
        return state.deviceSite;
    },
    get_deviceDepartment: (state) => {
        return state.deviceDepartment;
    },
    get_deviceCategory: (state) => {
        return state.deviceCategory;
    },
    get_deviceState: (state) => {
        return state.deviceState;
    },
    get_repairOper: (state) => {
        return state.repairOper;
    },
    get_repairDevice: (state) => {
        return state.repairDevice;
    },
}

const actions = {
    set_actOper: (context, arr) => {
        context.commit("SET_ACTOPER", arr);
    },
    set_device: (context, obj) => {
        context.commit("SET_DEVICE", obj);
    },
    set_group: (context, obj) => {
        context.commit("SET_GROUP", obj);
    },
    set_orgProcess: (context, arr) => {
        context.commit("SET_ORGPROCESS", arr);
    },
    set_htProcess: (context, arr) => {
        context.commit("SET_HTPROCESS", arr);
    },
    set_inspProcess: (context, arr) => {
        context.commit("SET_INSPPROCESS", arr);
    },
    set_oper: (context, arr) => {
        context.commit("SET_OPER", arr);
    },
    set_firmCategory: (context, arr) => {
        context.commit("SET_FIRMCATEGORY", arr);
    },
    set_deviceSite: (context, arr) => {
        context.commit("SET_DEVICESITE", arr);
    },
    set_deviceDepartment: (context, arr) => {
        context.commit("SET_DEVICEDEPARTMENT", arr);
    },
    set_deviceCategory: (context, arr) => {
        context.commit("SET_DEVICECATEGORY", arr);
    },
    set_deviceState: (context, arr) => {
        context.commit("SET_DEVICESTATE", arr);
    },
    set_repairOper: (context, obj) => {
        context.commit("SET_REPAIROPER", obj);
    },
    set_repairDevice: (context, arr) => {
        context.commit("SET_REPAIRDEVICE", arr);
    },
    set_options: (context, obj) => {
        context.commit("SET_OPTIONS", obj);
    },
}

const mutations = {
    SET_ACTOPER: (state, arr) => {
        state.actOper = arr;
    },
    SET_DEVICE: (state, obj) => {
        state.device = obj;
    },
    SET_GROUP: (state, obj) => {
        state.group = obj;
    },
    SET_ORGPROCESS: (state, arr) => {
        state.orgProcess = arr;
    },
    SET_HTPROCESS: (state, arr) => {
        state.htProcess = arr;
    },
    SET_INSPPROCESS: (state, arr) => {
        state.inspProcess = arr;
    },
    SET_OPER: (state, arr) => {
        state.oper = arr;
    },
    SET_FIRMCATEGORY: (state, arr) => {
        state.firmCategory = arr;
    },
    SET_DEVICESITE: (state, arr) => {
        state.deviceSite = arr;
    },
    SET_DEVICEDEPARTMENT: (state, arr) => {
        state.deviceDepartment = arr;
    },
    SET_DEVICECATEGORY: (state, arr) => {
        state.deviceCategory = arr;
    },
    SET_DEVICESTATE: (state, arr) => {
        state.deviceState = arr;
    },
    SET_REPAIROPER: (state, obj) => {
        state.repairOper = obj;
    },
    SET_REPAIRDEVICE: (state, arr) => {
        state.repairDevice = arr;
    },
    SET_OPTIONS: (state, obj) => {
        Object.entries(obj).forEach(([key, value]) => {
            state[key] = value;
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}